



<div class="po-search-search-container" (keydown)="onKeyDown($event)">
  <!-- Search Input -->
  <span class="p-input-icon-left po-search-input-wrapper">
    <i class="pi pi-search"></i>
    <input pInputText [(ngModel)]="searchCriteria"
           (keyup)="onKeyUp($event)"
           class="po-search"
           placeholder="Search PO / Shipping error # / Invoice / Order ID / Date"
           pTooltip="Search for your shipping number"
           [ngClass]="{'ng-touched': touched, 'ng-valid': valid, 'ng-invalid': !valid }" />
  </span>

  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="po-loading-spinner">
    <p-progressSpinner styleClass="small-spinner"></p-progressSpinner>
  </div>

  <!-- Search Results -->
  <div class="search-results" *ngIf="results.length > 0">

    <div class="po-card"
         *ngFor="let result of results; let i = index"
         [ngClass]="{active: activeIndex === i}"
         (click)="selectPO(result)"
         pTooltip="{{ result.products }}"
         tooltipStyleClass="line-broken-tooltip"
         tooltipPosition="top">

      <div class="po-meta">
        <span><i class="pi pi-box"></i> PO: <strong>{{ result.po }}</strong></span>
        <span><i class="pi pi-list"></i> Order ID: {{ result.orderid }}</span>
        <span><i class="pi pi-file"></i> Invoice: {{ result.invoice }}</span>
        <span><i class="pi pi-truck"></i> Shipping #: {{ result.shippingNumber }}</span>
        <span><i class="pi pi-calendar"></i> {{ result.dT_POSTED | date: 'MM-dd-yy' }}</span>
      </div>
    </div>
  </div>


  <div class="no-results"
       *ngIf="!isLoading && results && results.length === 0 && searchCriteria?.trim() && !selectedShippingProducts?.length">
    <i class="pi pi-info-circle"></i> No matching records found.
  </div>


  <div class="product-box" *ngIf="selectedShippingProducts?.length">
    <label class="selected-label mb-2 flex justify-between items-center">
      Products in selected shipping order:
    </label>


    <div class="flex flex-wrap items-center gap-3 mb-3">
      <!-- Search Input (flex-grow ensures it stretches nicely) -->
      <input type="text"
             [(ngModel)]="productSearchTerm"
             placeholder="Search products..."
             class="product-search flex-grow min-w-[200px]" />

      <!-- Sort + Clear Group -->
      <div class="flex items-center gap-2 flex-shrink-0">
        <select [(ngModel)]="productSortKey" class="clean-select w-40">
          <option value="code">Sort by Code</option>
          <option value="description">Sort by Description</option>
          <option value="quantity">Sort by Quantity</option>
        </select>

        <!-- Clear Button -->
        <!-- Clear Button -->
        <button type="button"
                (click)="clearProductSelection()"
                class="btn-primary"
                pTooltip="Clear selected products"
                tooltipPosition="top">
          <i class="pi pi-times"></i>
        </button>
      </div>

    </div>




    <div class="product-grid">
      <div class="po-card" *ngFor="let p of filteredSortedProducts" (click)="addFromPO(p)"
           pTooltip="Click to add product"
           tooltipPosition="top">
        <div class="po-meta compact-layout">
          <img class="product-thumb"
               [src]="'http://images.promaster.com/' + p.productCode + '.jpg'"
               (error)="onImageError($event)"
               alt="Product image" />
          <div class="info-block">
            <div class="sku">{{ p.productCode }}</div>
            <div class="desc">{{ p.productDescription }}</div>
          </div>
          <div class="qty-add">
            <div class="qty">x{{ p.productQuantity }}</div>
            <i class="pi pi-plus-circle add-icon"
               pTooltip="Add to Overage/Shortage grid"
               tooltipPosition="left"></i>
          </div>
        </div>
      </div>
    </div>



  </div>
